import {useMutation, useQueryClient} from '@github-ui/react-query'
import {fetchCAPI} from '../utils/fetch-capi'
import {taskUnarchiveApiPath} from '../utils/api-url-helpers'
import {agentTaskQueryKey} from './use-task'
import {agentTasksQueryKey} from './useTasks'

interface UseUnarchiveTaskArgs {
  taskId?: string
  repoNwo?: string
}

export function useUnarchiveTask({taskId, repoNwo}: UseUnarchiveTaskArgs) {
  const queryClient = useQueryClient()

  return useMutation({
    mutationKey: ['unarchiveTask', repoNwo, taskId],
    mutationFn: async () => {
      if (!taskId) {
        throw new Error('taskId is required')
      }
      const [repoOwner, repoName] = repoNwo?.split('/', 2) ?? []
      const path = taskUnarchiveApiPath(taskId, repoOwner, repoName)
      const response = await fetchCAPI({
        path,
        method: 'POST',
      })
      return response
    },
    onSuccess: () => {
      const [repoOwner, repoName] = repoNwo?.split('/', 2) ?? []
      queryClient.invalidateQueries({queryKey: agentTaskQueryKey(repoOwner, repoName, taskId)})
      if (repoOwner && repoName) {
        queryClient.invalidateQueries({queryKey: ['repo-tasks', repoOwner, repoName]})
      }
      queryClient.invalidateQueries({queryKey: agentTasksQueryKey})
    },
  })
}
